<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>溃坝风险分布</p>
        <el-button class="yjzb" size="mini" round @click="yjzbFun">预警指标</el-button>
        <el-switch class="elSwitch" style="display: block; float: right;" v-model="value" active-color="#13ce66"
          inactive-color="#409eff" active-text="饼图" inactive-text="柱图" @change="switchChange">
        </el-switch>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">淤地坝数量统计
        <el-button size="mini" round @click="bigdialogClick('yjydbNum')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="numAll!=0">总和：{{numAll}}</span>
          <div class="Piebar" id="yjnumbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">影响人数统计
        <el-button size="mini" round @click="bigdialogClick('yjyxrs')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="yxrsAll!=0">总和：{{yxrsAll}}</span>
          <div class="Piebar" id="yjyxrsbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">病险老旧坝影响人数统计
        <el-button size="mini" round @click="bigdialogClick('yjbxljyx')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="bxyxrsAll!=0">病险坝总和：{{bxyxrsAll}}</span>
          <span v-if="ljyxrsAll!=0" style="margin-left: 40px;">老旧坝总和：{{ljyxrsAll}}</span><br />
          <div class="Piebar" id="yjbxljyxbar"></div>
        </div>
      </div>
      <div class="contents">
        <p></p>
        <p class="title1">重要设施统计
        <el-button size="mini" round @click="bigdialogClick('yjzyss')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="zyssAll!=0">总和：{{zyssAll}}</span>
          <div class="Piebar" id="yjzyssbar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    //5.21
    selectYDBCount,
    selectYDBCountB,
    selectYDBYXRSSum,
    selectYDBYXRSSumB,
    selectYDBZYSSSum,
    selectYDBZYSSSumB,
    selectYDBLJBBXBYXRSSumB
  } from "@/api/api.js";
  export default {
    // props: ['nowState'],
    data() {
      return {
        show: false,

        yjnumbar: null,
        yjyxrsbar: null,
        yjbxljyxbar: null,
        yjzyssbar: null,
        jytjBar: null,

        numAll: 0,
        yxrsAll: 0,
        bxyxrsAll: 0,
        ljyxrsAll: 0,
        zyssAll: 0,

        xzqhCityName: [],
        xzqhCityId: [],
        dxBlueSum: 0,
        dxYellowSum: 0,
        dxOrangeSum: 0,
        dxRedSum: 0,
        zxBlueSum: 0,
        zxYellowSum: 0,
        zxOrangeSum: 0,
        zxRedSum: 0,
        BlueSum: [],
        YellowSum: [],
        OrangeSum: [],
        RedSum: [],

        blCityName: [],
        blCityId: [],
        bxBlueSum: 0,
        bxYellowSum: 0,
        bxOrangeSum: 0,
        bxRedSum: 0,
        ljBlueSum: 0,
        ljYellowSum: 0,
        ljOrangeSum: 0,
        ljRedSum: 0,

        yxrsCityName: [],
        yxrsCityId: [],
        YblueSum: [],
        YyellowSum: [],
        YorangeSum: [],
        YredSum: [],

        zyssCityName: [],
        zyssCityId: [],
        ZblueSum: [],
        ZyellowSum: [],
        ZorangeSum: [],
        ZredSum: [],

        ydbCodeLists: null,

        //饼柱切换
        value: false,
      };
    },
    mounted() {
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        yuShi: this.$store.state.yuShi
      };
      //获取淤地坝数量统计
      this.ydbtotalForRegionNew(params);
      //获取淤地坝数量统计按影响人数
      this.ydbtotalForYxrsNew(params);
      //获取淤地坝数量按老旧病险坝影响人数饼图
      this.ydbtotalForljbxyxNew(params);
      //获取淤地坝数量统计按重要设施
      this.ydbtotalForZyssNew(params);
    },
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
      myydbDataFuns() {
        return this.$store.state.myydbData; //需要监听的数据
      },
      yuShiFuns() {
        return this.$store.state.yuShi; //需要监听的数据
      },
    },
    watch: {
      nowxingzhengCodes(newVal, oldVal) {
        if (oldVal) {
          let params;
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              regionCode: newVal,
              yuShi: this.$store.state.yuShi
            };
          } else {
            params = {
              regionCode: newVal,
              ydbCodeList: this.$store.state.myydbData,
              yuShi: this.$store.state.yuShi
            };
          }
          if(this.value == false){
            //获取淤地坝数量统计
            this.ydbtotalForRegionNew(params);
            //获取淤地坝数量统计按影响人数
            this.ydbtotalForYxrsNew(params);
            //获取淤地坝数量按老旧病险坝影响人数饼图
            this.ydbtotalForljbxyxNew(params);
            //获取淤地坝数量统计按重要设施
            this.ydbtotalForZyssNew(params);
          }else {
            //获取淤地坝数量统计
            this.ydbtotalForRegion(params);
            //获取淤地坝数量统计按影响人数
            this.ydbtotalForYxrs(params);
            //获取淤地坝数量统计按重要设施
            this.ydbtotalForZyss(params);
          }
        }
      },
      myydbDataFuns(newVal, oldVal) {
        if (oldVal != null) {
          let params;
          this.ydbCodeLists = newVal;
          if (this.$store.state.ydbryorssShow == false && this.$store.state.kxcxStatus == false && this.$store.state
            .dzmcxStatus == false && this.$store.state.dtjcxStatus == false) {
            params = {
              regionCode: this.$store.state.nowxingzhengCode,
              yuShi: this.$store.state.yuShi
            };
          } else {
            params = {
              regionCode: this.$store.state.nowxingzhengCode,
              ydbCodeList: newVal,
              yuShi: this.$store.state.yuShi
            };
          }

          if(this.value == false){
            //获取淤地坝数量统计
            this.ydbtotalForRegionNew(params);
            //获取淤地坝数量统计按影响人数
            this.ydbtotalForYxrsNew(params);
            //获取淤地坝数量按老旧病险坝影响人数饼图
            this.ydbtotalForljbxyxNew(params);
            //获取淤地坝数量统计按重要设施
            this.ydbtotalForZyssNew(params);
          }else {
            //获取淤地坝数量统计
            this.ydbtotalForRegion(params);
            //获取淤地坝数量统计按影响人数
            this.ydbtotalForYxrs(params);
            //获取淤地坝数量统计按重要设施
            this.ydbtotalForZyss(params);
          }
        }
      },
      yuShiFuns(newVal, oldVal) {
        let params = {
          regionCode: this.$store.state.nowxingzhengCode,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: newVal
        };
        if(this.value == false){
          //获取淤地坝数量统计
          this.ydbtotalForRegionNew(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrsNew(params);
          //获取淤地坝数量按老旧病险坝影响人数饼图
          this.ydbtotalForljbxyxNew(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyssNew(params);
        }else {
          //获取淤地坝数量统计
          this.ydbtotalForRegion(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrs(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyss(params);
        }
      },
    },
    methods: {
      //预警指标
      yjzbFun() {
        this.$emit('pdfShow', true);
      },

      //饼柱图切换
      switchChange(value) {
        // console.log(value)
        this.numAll = 0;
        this.yxrsAll = 0;
        this.zyssAll = 0;

        this.$emit("bzswitch", value);
        let params = {
          regionCode: this.$store.state.nowxingzhengCode,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: this.$store.state.yuShi
        };
        if(value == false){//饼图
          //获取淤地坝数量统计
          this.ydbtotalForRegionNew(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrsNew(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyssNew(params);
        }else {//柱图
          //获取淤地坝数量统计
          this.ydbtotalForRegion(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrs(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyss(params);
        }
      },

      //大图点击事件
      bigdialogClick(type) {
        let echartsData = {};
        echartsData.type = type;
        echartsData.isBar = this.value;
        if (type == 'yjydbNum') {
          echartsData.title = '淤地坝数量统计';
          echartsData.xzqhCityName = this.xzqhCityName;
          echartsData.xzqhCityId = this.xzqhCityId;
          echartsData.dxBlueSum = this.dxBlueSum;
          echartsData.dxYellowSum = this.dxYellowSum;
          echartsData.dxOrangeSum = this.dxOrangeSum;
          echartsData.dxRedSum = this.dxRedSum;
          echartsData.zxBlueSum = this.zxBlueSum;
          echartsData.zxYellowSum = this.zxYellowSum;
          echartsData.zxOrangeSum = this.zxOrangeSum;
          echartsData.zxRedSum = this.zxRedSum;
          echartsData.BlueSum = this.BlueSum;
          echartsData.YellowSum = this.YellowSum;
          echartsData.OrangeSum = this.OrangeSum;
          echartsData.RedSum = this.RedSum;
        } else if (type == 'yjyxrs') {
          echartsData.title = '影响人数统计';
          echartsData.yxrsCityName = this.yxrsCityName;
          echartsData.yxrsCityId = this.yxrsCityId;
          echartsData.YblueSum = this.YblueSum;
          echartsData.YyellowSum = this.YyellowSum;
          echartsData.YorangeSum = this.YorangeSum;
          echartsData.YredSum = this.YredSum;
        } else if (type == 'yjbxljyx') {
          echartsData.title = '病险老旧坝影响人数统计';
          echartsData.blCityName = this.blCityName;
          echartsData.blCityId = this.blCityId;
          echartsData.bxBlueSum = this.bxBlueSum;
          echartsData.bxYellowSum = this.bxYellowSum;
          echartsData.bxOrangeSum = this.bxOrangeSum;
          echartsData.bxRedSum = this.bxRedSum;
          echartsData.ljBlueSum = this.ljBlueSum;
          echartsData.ljYellowSum = this.ljYellowSum;
          echartsData.ljOrangeSum = this.ljOrangeSum;
          echartsData.ljRedSum = this.ljRedSum;
        } else if (type == 'yjzyss') {
          echartsData.title = '重要设施统计';
          echartsData.zyssCityName = this.zyssCityName;
          echartsData.zyssCityId = this.zyssCityId;
          echartsData.ZblueSum = this.ZblueSum;
          echartsData.ZyellowSum = this.ZyellowSum;
          echartsData.ZorangeSum = this.ZorangeSum;
          echartsData.ZredSum = this.ZredSum;
        }
        this.$emit("bigDialogData", echartsData);
      },

      //获取淤地坝数量统计柱图
      ydbtotalForRegion(params) {
        this.xzqhCityName = [];
        this.xzqhCityId = [];
        this.BlueSum = [];
        this.YellowSum = [];
        this.OrangeSum = [];
        this.RedSum = [];
        selectYDBCount(params).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            this.xzqhCityName.push(res.data[i].addressName);
            this.xzqhCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.BlueSum.push(res.data[i].blueSum);
            this.YellowSum.push(res.data[i].yellowSum);
            this.OrangeSum.push(res.data[i].orangeSum);
            this.RedSum.push(res.data[i].redSum);
          }
          this.xzqbar(this.xzqhCityId, this.xzqhCityName, this.BlueSum, this.YellowSum, this.OrangeSum, this.RedSum);
        });
      },

      //获取淤地坝数量统计饼图
      ydbtotalForRegionNew(params) {
        this.xzqhCityName = ['全部地区'];
        this.dxBlueSum = 0;
        this.dxYellowSum = 0;
        this.dxOrangeSum = 0;
        this.dxRedSum = 0;
        this.zxBlueSum = 0;
        this.zxYellowSum = 0;
        this.zxOrangeSum = 0;
        this.zxRedSum = 0;
        selectYDBCountB(params).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].ydbbx=="大型") {
              this.dxBlueSum = Number(res.data[i].blueSum);
              this.dxYellowSum = Number(res.data[i].yellowSum);
              this.dxOrangeSum = Number(res.data[i].orangeSum);
              this.dxRedSum = Number(res.data[i].redSum);
            } else if (res.data[i].ydbbx=="中型") {
              this.zxBlueSum = Number(res.data[i].blueSum);
              this.zxYellowSum = Number(res.data[i].yellowSum);
              this.zxOrangeSum = Number(res.data[i].orangeSum);
              this.zxRedSum = Number(res.data[i].redSum);
            }
          }
          this.xzqbarNew(this.xzqhCityName, this.dxBlueSum, this.dxYellowSum, this.dxOrangeSum, this.dxRedSum,
          this.zxBlueSum, this.zxYellowSum, this.zxOrangeSum, this.zxRedSum);
        });
      },

      //影响人数统计柱图
      ydbtotalForYxrs(params) {
        this.yxrsCityName = [];
        this.yxrsCityId = [];
        this.YblueSum = [];
        this.YyellowSum = [];
        this.YorangeSum = [];
        this.YredSum = [];
        selectYDBYXRSSum(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.yxrsCityName.push(res.data[i].addressName);
            this.yxrsCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.YblueSum.push(res.data[i].blueSum);
            this.YyellowSum.push(res.data[i].yellowSum);
            this.YorangeSum.push(res.data[i].orangeSum);
            this.YredSum.push(res.data[i].redSum);
          }
          this.yxrsbar(this.yxrsCityId, this.yxrsCityName, this.YblueSum, this.YyellowSum, this.YorangeSum, this
            .YredSum);
        });
      },

      //影响人数统计饼图
      ydbtotalForYxrsNew(params) {
        this.yxrsCityName = '全部地区';
        this.YblueSum = 0;
        this.YyellowSum = 0;
        this.YorangeSum = 0;
        this.YredSum = 0;
        selectYDBYXRSSumB(params).then((res) => {
          this.YblueSum = Number(res.data[0].blueSum);
          this.YyellowSum = Number(res.data[0].yellowSum);
          this.YorangeSum = Number(res.data[0].orangeSum);
          this.YredSum = Number(res.data[0].redSum);
          this.yxrsbarNew(this.yxrsCityName, this.YblueSum, this.YyellowSum, this.YorangeSum, this.YredSum);
        });
      },

      //获取淤地坝数量按老旧病险坝影响人数饼图
      ydbtotalForljbxyxNew(params) {
        this.blCityName = ['全部地区'];
        this.bxBlueSum = 0;
        this.bxYellowSum = 0;
        this.bxOrangeSum = 0;
        this.bxRedSum = 0;
        this.ljBlueSum = 0;
        this.ljYellowSum = 0;
        this.ljOrangeSum = 0;
        this.ljRedSum = 0;
        selectYDBLJBBXBYXRSSumB(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.bxBlueSum = Number(res.data[i].bxblueSum);
            this.bxYellowSum = Number(res.data[i].bxyellowSum);
            this.bxOrangeSum = Number(res.data[i].bxorangeSum);
            this.bxRedSum = Number(res.data[i].bxredSum);
            this.ljBlueSum = Number(res.data[i].ljblueSum);
            this.ljYellowSum = Number(res.data[i].ljyellowSum);
            this.ljOrangeSum = Number(res.data[i].ljorangeSum);
            this.ljRedSum = Number(res.data[i].ljredSum);
          }
          this.ljbxyxbarNew(this.blCityName, this.bxBlueSum, this.bxYellowSum, this.bxOrangeSum, this.bxRedSum,
          this.ljBlueSum, this.ljYellowSum, this.ljOrangeSum, this.ljRedSum);
        });
      },

      //获取淤地坝数量统计按重要设施柱图
      ydbtotalForZyss(params) {
        this.zyssCityName = [];
        this.zyssCityId = [];
        this.ZblueSum = [];
        this.ZyellowSum = [];
        this.ZorangeSum = [];
        this.ZredSum = [];
        selectYDBZYSSSum(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.zyssCityName.push(res.data[i].addressName);
            this.zyssCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.ZblueSum.push(res.data[i].blueSum);
            this.ZyellowSum.push(res.data[i].yellowSum);
            this.ZorangeSum.push(res.data[i].orangeSum);
            this.ZredSum.push(res.data[i].redSum);
          }
          this.zyssbar(this.zyssCityId, this.zyssCityName, this.ZblueSum, this.ZyellowSum, this.ZorangeSum, this.ZredSum);
        });
      },

      //获取淤地坝数量统计按重要设施饼图
      ydbtotalForZyssNew(params) {
        this.zyssCityName = '全部地区';
        this.ZblueSum = 0;
        this.ZyellowSum = 0;
        this.ZorangeSum = 0;
        this.ZredSum = 0;
        selectYDBZYSSSumB(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.ZblueSum = Number(res.data[i].blueSum);
            this.ZyellowSum = Number(res.data[i].yellowSum);
            this.ZorangeSum = Number(res.data[i].orangeSum);
            this.ZredSum = Number(res.data[i].redSum);
          }
          this.zyssbarNew(this.zyssCityName, this.ZblueSum, this.ZyellowSum, this.ZorangeSum, this.ZredSum);
        });
      },

      //淤地坝数量统计柱图
      xzqbar(xzqhCityId, xzqhCityName, BlueSum, YellowSum, OrangeSum, RedSum) {
        let _this = this;
        this.yjnumbar = this.$echarts.init(document.getElementById("yjnumbar"));

        this.yjnumbar.on('click', function(value) {
          if (value.componentSubType == 'bar') {
            let currentObject = [];
            let JYDJ;
            if (value.seriesName == '一级') {
              JYDJ = 'RED';
            } else if (value.seriesName == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.seriesName == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            for (let i = 0; i < xzqhCityId.length; i++) {
              if (value.name == xzqhCityId[i].name) {
                currentObject.push({
                  regionCode: xzqhCityId[i].code,
                  JYDJ: JYDJ,
                  yuShi: _this.$store.state.yuShi,
                });
              }
            }
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          title: {
            show: false,
            text: "",
            textStyle: {
              fontSize: 25,
              fontWeight: "normal",
              color: "#fff",
            },
            x: "center",
          },

          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: "2%",
            right: "2%",
            bottom: "10%",
            top: "20%",
            containLabel: true,
          },
          legend: {
            data: ["四级", "三级", "二级", "一级"],
            /*right: 10,*/
            // top: "4%",
            textStyle: {
              color: "#fff",
              fontSize: 12
            },
            itemWidth: 12,
            itemHeight: 10,
            // itemGap: 35
            selected: {
              '四级': false
            },
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 50, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }, ],
          xAxis: {
            type: "category",
            data: xzqhCityName,
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              textStyle: {
                fontFamily: "Microsoft YaHei",
                fontSize: 14
              },
            },
          },

          yAxis: {
            name: "数量",
            type: "value",
            // max: "150",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
            axisLabel: {},
          },

          series: [{
              name: "四级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                },
              },
              data: BlueSum,
            },
            {
              name: "三级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                },
              },
              data: YellowSum,
            },
            {
              name: "二级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                },
              },
              data: OrangeSum,
            },
            {
              name: "一级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                },
              },
              data: RedSum,
            },
          ],
        };
        this.yjnumbar.clear();
        this.yjnumbar.setOption(option);
      },

      //淤地坝数量统计饼图
      xzqbarNew(xzqhCityName, dxBlueSum, dxYellowSum, dxOrangeSum, dxRedSum, zxBlueSum, zxYellowSum, zxOrangeSum, zxRedSum) {
        let _this = this;
        this.yjnumbar = this.$echarts.init(document.getElementById("yjnumbar"));
        this.numAll = Number(dxYellowSum) + Number(dxOrangeSum) + Number(dxRedSum) +
        Number(zxYellowSum) + Number(zxOrangeSum) + Number(zxRedSum);

        // 点击图标
        this.yjnumbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let bx, JYDJ;
            if (value.data.type == "大型坝") {
              bx = '大型';
            } else{
              bx = '中型';
            }
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                bx: bx,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
        });
        let  option = {
          title : [{
              text: '大型坝',
              left: '17%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }, {
              text: '中型坝',
              left: '67%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }],
          legend: {
            left:'right',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name: "二级"},{name: "一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: xzqhCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['25%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: dxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'大型坝'},
                { value: dxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'大型坝'},
                { value: dxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'大型坝'},
                { value: dxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'大型坝'},
              ]
            },
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['75%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: zxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'中型坝'},
                { value: zxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'中型坝'},
                { value: zxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'中型坝'},
                { value: zxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'中型坝'},
              ]
            },
          ]
        };
        this.yjnumbar.clear();
        this.yjnumbar.setOption(option);
      },

      //影响人数统计柱图
      yxrsbar(yxrsCityId, yxrsCityName, YblueSum, YyellowSum, YorangeSum, YredSum) {
        let _this = this;
        this.yjyxrsbar = this.$echarts.init(document.getElementById("yjyxrsbar"));

        this.yjyxrsbar.on('click', function(value) {
          if (value.componentSubType == 'bar') {
            let currentObject = [];
            let JYDJ;
            if (value.seriesName == '一级') {
              JYDJ = 'RED';
            } else if (value.seriesName == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.seriesName == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            for (let i = 0; i < yxrsCityId.length; i++) {
              if (value.name == yxrsCityId[i].name) {
                currentObject.push({
                  regionCode: yxrsCityId[i].code,
                  JYDJ: JYDJ,
                  yuShi: _this.$store.state.yuShi,
                  sfyr: 1
                });
              }
            }
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '10%',
            top: '20%',
            containLabel: true
          },
          legend: {
            data: ['四级', '三级', '二级', '一级'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10,
            selected: {
              '四级': false
            },
          },
          xAxis: {
            type: 'category',
            data: yxrsCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 20, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '四级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE ",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 5,
                },
              },
              data: YblueSum
            },
            {
              name: '三级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: YyellowSum
            },
            {
              name: '二级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500 ",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: YorangeSum
            },
            {
              name: '一级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: YredSum
            },
          ]
        };
        this.yjyxrsbar.clear();
        this.yjyxrsbar.setOption(option);
      },

      //影响人数统计饼图
      yxrsbarNew(yxrsCityName, YblueSum, YyellowSum, YorangeSum, YredSum) {
        let _this = this;
        this.yjyxrsbar = this.$echarts.init(document.getElementById("yjyxrsbar"));
        this.yxrsAll = Number(YyellowSum) + Number(YorangeSum) + Number(YredSum);

        this.yjyxrsbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let JYDJ;
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                sfyr: 1,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
        });

        let  option = {
          legend: {
            left:'right',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name:"二级"},{name: "一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: yxrsCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: YblueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: YyellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: YorangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: YredSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
          ]
        };
        this.yjyxrsbar.clear();
        this.yjyxrsbar.setOption(option);
      },

      //老旧病险坝影响人数统计饼图
      ljbxyxbarNew(xzqhCityName, dxBlueSum, dxYellowSum, dxOrangeSum, dxRedSum, zxBlueSum, zxYellowSum, zxOrangeSum, zxRedSum) {
        let _this = this;
        this.yjbxljyxbar = this.$echarts.init(document.getElementById("yjbxljyxbar"));
        this.bxyxrsAll = Number(dxYellowSum) + Number(dxOrangeSum) + Number(dxRedSum);
        this.ljyxrsAll = Number(zxYellowSum) + Number(zxOrangeSum) + Number(zxRedSum);

        // 点击图标
        this.yjbxljyxbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let bxlj, JYDJ;
            if (value.data.type == "病险坝") {
              bxlj = 'bx';
            } else{
              bxlj = 'lj';
            }
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                bxlj: bxlj,
                sfyr: 1,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
        });
        let  option = {
          title : [{
              text: '病险坝',
              left: '17%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }, {
              text: '老旧坝',
              left: '67%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }],
          legend: {
            left:'center',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name: "二级"},{name: "一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: xzqhCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['25%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: dxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'病险坝'},
                { value: dxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'病险坝'},
                { value: dxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'病险坝'},
                { value: dxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'病险坝'},
              ]
            },
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['75%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: zxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'老旧坝'},
                { value: zxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'老旧坝'},
                { value: zxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'老旧坝'},
                { value: zxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'老旧坝'},
              ]
            },
          ]
        };
        this.yjbxljyxbar.clear();
        this.yjbxljyxbar.setOption(option);
      },

      //重要设施统计柱图
      zyssbar(zyssCityId, zyssCityName, ZblueSum, ZyellowSum, ZorangeSum, ZredSum) {
        let _this = this;
        this.yjzyssbar = this.$echarts.init(document.getElementById("yjzyssbar"));
        this.yjzyssbar.on('click', function(value) {
          if (value.componentSubType == 'bar') {
            let currentObject = [];
            let JYDJ;
            if (value.seriesName == '一级') {
              JYDJ = 'RED';
            } else if (value.seriesName == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.seriesName == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            for (let i = 0; i < zyssCityId.length; i++) {
              if (value.name == zyssCityId[i].name) {
                currentObject.push({
                  regionCode: zyssCityId[i].code,
                  JYDJ: JYDJ,
                  yuShi: _this.$store.state.yuShi,
                  zyss: 1
                });
              }
            }
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '10%',
            top: '20%',
            containLabel: true
          },
          legend: {
            data: ['四级', '三级', '二级', '一级'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10,
            selected: {
              '四级': false
            },
          },
          xAxis: {
            type: 'category',
            data: zyssCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 30, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '四级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE ",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 12,
                },
              },
              data: ZblueSum
            },
            {
              name: '三级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: ZyellowSum
            },
            {
              name: '二级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500 ",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: ZorangeSum
            },
            {
              name: '一级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51 ",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: ZorangeSum
            },
          ]
        };
        this.yjzyssbar.clear();
        this.yjzyssbar.setOption(option);
      },

      //重要设施统计饼图
      zyssbarNew(zyssCityName, ZblueSum, ZyellowSum, ZorangeSum, ZredSum) {
        let _this = this;
        this.yjzyssbar = this.$echarts.init(document.getElementById("yjzyssbar"));
        this.zyssAll = Number(ZblueSum) + Number(ZyellowSum) + Number(ZorangeSum) + Number(ZredSum);
        this.yjzyssbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let JYDJ;
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                zyss: 1,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
          });

        let option = {
          legend: {
            left:'right',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name:"二级"},{name:"一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: zyssCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: ZblueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: ZyellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: ZorangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: ZredSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
          ]
        };
        this.yjzyssbar.clear();
        this.yjzyssbar.setOption(option);
      },

      Cancel() {
        this.DialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 1100px;
    background: url(../../common/images/dbg.png) no-repeat center;
    background-size: 100% 100%;
  }

  .contents {
    width: 96%;
    height: 23.5%;
    margin-left: 2%;
    margin-top: 1%;
  }

  .contents p:nth-child(1) {
    float: left;
    width: 6px;
    height: 6px;
    margin: 12px 5px 12px 10px;
    background-color: #00B3FE;
  }

  .boderBottom {
    border-bottom: 1px dotted #ccc;
  }

  .title1 {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #00B3FE;
  }

  .Piebar {
    width: 100%;
    height: 220px;
  }

  .Piebar>span{
    float: left;
    margin-top: 5px;
    margin-left: 10px;
    color: #fff;
    font-size: 14px;
  }

  .yjzb {
    padding-top: 0px !important;
    margin-left: 5px;
    margin-top: 5px;
  }

  >>>.el-switch__label {
    color: #fff;
    height: 30px;
    line-height: 30px;
    margin: 5px;
  }

  >>>.el-switch__label.is-active {
    color: #409EFF;
  }

  >>>.el-button--mini, .el-button--mini.is-round {
    padding: 3px 10px;
    background: transparent;
    color: #fff;
    border: 1px solid #409EFF;
  }

  >>>.tit span {
    margin-top: 3px;
  }
</style>
